import { Icon } from "./Icon";

interface AudioControlButtonProps {
  isPlaying: boolean;
  onToggle: () => void;
}

export function AudioControlButton({
  isPlaying,
  onToggle,
}: AudioControlButtonProps) {
  return (
    <button
      onClick={onToggle}
      className="cursor-pointer w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all duration-200 group shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center"
      aria-label={isPlaying ? "Mute audio" : "Enable audio"}
    >
      <Icon
        icon={isPlaying ? "volume" : "volume-xmark"}
        className="text-white/90 text-xl group-hover:text-white transition-colors"
      />
    </button>
  );
}
